import React from 'react';
import { TimeRangePicker as TimeRangePickerNew } from './TimeRangePicker';
import { convertOldTimeRangePickerProps, OldTimeRangePickerProps } from './converter.old';

export type TimeRangePickerProps = OldTimeRangePickerProps;
export const TimeRangePicker: React.FC<TimeRangePickerProps> = (props) => (
  <TimeRangePickerNew {...convertOldTimeRangePickerProps(props)} />
);
